<template>
	<div class="auth-page">
		<div class="auth-page__layer auth-page__layer--base" aria-hidden="true"></div>
		<div class="auth-page__layer auth-page__layer--grid" aria-hidden="true"></div>
		<div class="auth-page__layer auth-page__layer--glow" aria-hidden="true"></div>

		<div class="auth-page__shell" :class="{ 'auth-page__shell--wide': wide }">
			<aside class="auth-panel auth-panel--brand">
				<div class="auth-panel__inner">
					<div class="auth-brand">
						<img class="auth-brand__logo" src="@/assets/common/logo.png" alt="绿地畅聊" />
						<h1 class="auth-brand__title">{{ title }}</h1>
						<p v-if="subtitle" class="auth-brand__subtitle">{{ subtitle }}</p>
						<p class="auth-brand__tagline">{{ tagline }}</p>
					</div>
					<ul class="auth-features" aria-hidden="true">
						<li v-for="item in featureList" :key="item">{{ item }}</li>
					</ul>
				</div>
			</aside>

			<main class="auth-panel auth-panel--form">
				<div class="auth-panel__inner">
					<div class="auth-form-header" v-if="formTitle">
						<h2 class="auth-form-header__title">{{ formTitle }}</h2>
						<p v-if="formSubtitle" class="auth-form-header__subtitle">{{ formSubtitle }}</p>
					</div>
					<div class="auth-card__body">
						<slot></slot>
					</div>
					<footer
						v-if="$slots.footer"
						class="auth-card__footer"
						:class="{ 'auth-card__footer--center': footerCenter }"
					>
						<slot name="footer"></slot>
					</footer>
				</div>
			</main>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AuthLayout',
	props: {
		title: {
			type: String,
			default: '绿地畅聊'
		},
		subtitle: {
			type: String,
			default: ''
		},
		tagline: {
			type: String,
			default: 'A secure and efficient instant messaging platform'
		},
		formTitle: {
			type: String,
			default: ''
		},
		formSubtitle: {
			type: String,
			default: ''
		},
		wide: {
			type: Boolean,
			default: false
		},
		footerCenter: {
			type: Boolean,
			default: false
		},
		features: {
			type: Array,
			default: null
		}
	},
	computed: {
		featureList() {
			if (this.features && this.features.length) {
				return this.features;
			}
			return [
				'Enterprise-grade security',
				'Real-time collaboration',
				'Cross-platform access'
			];
		}
	}
};
</script>

<style lang="scss">
@import '@/assets/style/auth.scss';
</style>
